/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import {  isBefore, startOfDay } from "date-fns";
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, InputGroup, Row } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { useNavigate } from "react-router-dom";
import { Button, Input, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllSessionList } from "../../redux/Slice/Sessions/SessionsListSlice";
import { ArchiveSession } from "./ArchiveSession";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { initialColumns } from "./session.utils";
import { SessionFilterModal } from "./SessionFilterModal";
import { toast } from "react-toastify";

const ListOfSessions = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { AllSessionsData, errorMessage } = useAppSelector((state) => state.sessionList);
  const { SelectedFacility = "" } = useAppSelector(
    (state) => state.facilityList
  );

  const [archive, setArchive] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [displayData, setDisplayData] = useState(AllSessionsData);
  const [searchValue, setSearchValue] = useState("");
  const [columns, setColumns] = useState([...initialColumns]);

  const [sportName, setSportName] = useState("");
  const [sessionStatus, setSessionStatus] = useState("");
  const [show, setShow] = useState(false);
  if (errorMessage) {
    toast.error(errorMessage.message)
  }
  const ALL_COLUMNS = [
    {
      value: "Session Name",
      labelKey: "name",
    },
    {
      value: "Sport Name",
      labelKey: "sportName",
    },
    {
      value: "Session Period",
      labelKey: "sessionPeriod",
    },
    {
      value: "Weekly Days",
      labelKey: "weeklyDays",
    },
    {
      value: "Total Session",
      labelKey: "totalSession",
    },
    {
      value: "Completed Sessions",
      labelKey: "completedSessions",
    },
    {
      value: "Attendees Limit",
      labelKey: "attendeesLimit",
    },
    {
      value: "Current Attendees",
      labelKey: "currentAttendees",
    },
    {
      value: "Status",
      labelKey: "sessionStatus",
    },
    {
      value: "Coach Name",
      labelKey: "coachName",
    },
  ];

  useEffect(() => {
    setDisplayData(AllSessionsData);
  }, [AllSessionsData]);



  useEffect(() => {
    dispatch(AllSessionList(SelectedFacility));
  }, [SelectedFacility]);

  const handleAdd = () => {
    navigate("/create-session");
  };

  const handleEdit = (id: string) => {
    navigate(`/update-session/${id}`, { state: id });
  };

  const handleUserInfo = (row: any) => {
    navigate(`/session-detail/${row}`, { state: row });
  };

  const HandleDelete = (id: string) => {
    setArchive(true);
    setDeleteId(id);
  };

  const handleFromDate = (date: any) => {
    setFromDate(date?.toDate().toUTCString());
  };

  const handleToDate = (date: any) => {
    setToDate(date?.toDate().toUTCString());
  };

  const getFormatedDate = (_date: string) => {
    if (!_date) {
      return new Date();
    }
    if (_date?.includes?.("GMT")) {
      return new Date(_date);
    }
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return new Date(`${_mm}/${_dd}/${_yy}`);
  };

  const filterDataByDate = (
    value: string = "",
    checkSearch: boolean = false
  ) => {
    let filterData = AllSessionsData?.filter?.((_data: any) => {
      if (!fromDate && !toDate) {
        return true;
      }
      if (fromDate && !toDate) {
        return (
          new Date(getFormatedDate(_data?.rawData?.startDate)) >=
          startOfDay(getFormatedDate(fromDate))
        );

      }
      if (!fromDate && toDate) {

        return isBefore(
          getFormatedDate(_data?.rawData?.endDate),
          new Date(toDate)
        );
      }
      if (fromDate && toDate) {
        return (
          (new Date(getFormatedDate(_data?.rawData?.startDate)) <=
            startOfDay(getFormatedDate(fromDate)) &&
            new Date(getFormatedDate(_data?.rawData?.endDate)) >=
            startOfDay(getFormatedDate(fromDate))) ||
          (new Date(getFormatedDate(_data?.rawData?.startDate)) <=
            startOfDay(getFormatedDate(toDate)) &&
            new Date(getFormatedDate(_data?.rawData?.endDate)) >=
            startOfDay(getFormatedDate(toDate)))
        );

      }


    });
    if (checkSearch) {
      if (value?.length > 2) {
        filterData = filterData?.filter?.((_data: any) =>
          _data?.name?.toLowerCase()?.includes?.(value?.toLowerCase())
        );
      }
    } else {
      if (searchValue?.length > 2) {
        filterData = filterData?.filter?.((_data: any) =>
          _data?.name?.toLowerCase()?.includes?.(searchValue?.toLowerCase())
        );
      }
    }
    if (sportName) {
      filterData = filterData?.filter?.(
        (_data: any) => _data?.rawData?.sport?.id == sportName
      );
    }
    if (sessionStatus) {
      filterData = filterData?.filter?.(
        (_data: any) => _data?.rawData?.status === sessionStatus
      );
    }
    setDisplayData(filterData);
  };

  const handleClear = () => {
    setFromDate("");
    setToDate("");
    setSearchValue("");
    setSessionStatus("");
    setSportName("");
    setDisplayData(AllSessionsData);
  };

  const handleSearch = (value: string) => {
    setSearchValue(value);
    if (!value) {
      setDisplayData(AllSessionsData);
    }
    if (value?.length > 2) {
      filterDataByDate(value, true);
    }
  };

  const handleChange = (value: any) => {
    const col = value.selectedValue.map((item: string, index: number) => {
      return {
        Header: item,
        accessor: value.selectedKey[index],
      };
    });
    setColumns(col);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFilterSubmit = () => {
    filterDataByDate();
    setShow(false);
  };

  const defaultColumn = [...columns].map((item) => item.accessor);

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Session List</Card.Title>
            <ButtonGroup>
              <Button
                type="button"
                bname="Filter"
                onClick={handleShow}
                className="btn btn-light me-2 rounded-1 text-dark text-info fitler-img"
                id="filter"
                name="filter"
              ></Button>
              <Button
                onClick={handleAdd}
                type="button"
                bname="Add Session"
                name="add-session"
                id="add-session"
                className="btn btn-primary rounded-1 me-2"
              ></Button>
              <BootstrapSelect
                options={ALL_COLUMNS}
                isMultiSelect={true}
                showTick={true}
                defaultOptions={defaultColumn}

                showSearch={true}
                showAction={true}
                placeholder="Select Column "
                className="edit-column"
                selectStyle="btn-primary"
                actionBtnStyle="btn-outline-primary"
                onChange={handleChange}
              />
            </ButtonGroup>
          </div>
          <Row className="row-mb">
            <Col lg={3} style={{ paddingTop: "31px" }}>
              <div className="text-start">
                <InputGroup>
                  <Input
                    onChange={(e: any) => handleSearch(e?.target?.value)}
                    value={searchValue}
                    type="text"
                    name="search"
                    id="search"
                    className="form-control form-control-sm h-auto"
                    placeholder="Search by session..."
                  />
                </InputGroup>
              </div>
            </Col>
            <Col lg={4}>
              <label className="form-label me-1">Start Date : </label>
              <DatePicker
                format="DD/MM/YYYY"
                value={new Date(fromDate)}
                onChange={handleFromDate}
                render={
                  <InputIcon className="form-control form-control-sm h-auto" />
                }
              />
            </Col>
            <Col lg={4} className="position-relative">
              <InputGroup className="align-items-center">
                <label className="form-label me-1">End Date : </label>
                <DatePicker
                  format="DD/MM/YYYY"
                  value={new Date(toDate)}
                  onChange={handleToDate}
                  minDate={fromDate ? new Date(fromDate) : undefined}
                  render={
                    <InputIcon className="form-control form-control-sm h-auto" />
                  }
                />
                <Button
                  onClick={filterDataByDate}
                  type="button"
                  bname="Go"
                  name="Go-button"
                  id="go-button"
                  className="btn btn-primary btn-sm rounded-1"
                />
              </InputGroup>
              {(fromDate ||
                toDate ||
                searchValue ||
                sessionStatus ||
                sportName) && (
                  <div
                    onClick={handleClear}
                    className="btn btn-link position-absolute top-0"
                    style={{ cursor: "pointer", left: "100%", paddingTop: '31px' }}
                  >
                    Clear
                  </div>
                )}
            </Col>

            <Col lg={1}></Col>
          </Row>
        </Card.Body>
        <Table
          columns={columns}
          data={displayData}
          handleEdit={handleEdit}
          HandleShow={handleUserInfo}
          HandleDelete={HandleDelete}

          hideEditAction={false}
          hideGlobalFilter={true}
          show={true}
          paginationReadOnly={true}
          hideViewAction={true}
        />
        {archive && (
          <ArchiveSession
            setArchive={setArchive}
            archive={archive}
            id={deleteId}
          />
        )}
      </Card>
      <SessionFilterModal
        show={show}
        handleClose={handleClose}
        sportName={sportName}
        setSportName={setSportName}
        sessionstatus={sessionStatus}
        setSessionStatus={setSessionStatus}
        handleFilterSubmit={handleFilterSubmit}
      />
    </>
  );
};
export { ListOfSessions };
